module.exports = __webpack_public_path__ + "static/benevity-logo-b32ddb66da86242fd7ee0fc019c77df8.png";